import styled from 'styled-components'

export const PaginationFooterStyled = styled.div`
  padding-top: ${({ theme }) => theme.space.medium};
`
